<script lang="ts">
  import { Views, href } from "../../../utils/Constant/Constant";
  import data from "../../../Data/Tasks/Tasks.json"
  import Link from "svelte-link";
  import {tasksTabId} from "../../../store"
  // for get tab id
  const handleTab = (getId:string) => {
    tasksTabId.update(value => value = getId)
  }
  let setTasksTab:string
  tasksTabId.subscribe((value)=>{
    setTasksTab = value
  })
</script>

<li class="nav-item">
  <span class="main-title"> {Views}</span>
</li>
{#each data.viewstabdata as taskItem}
    <li>
        <Link id={taskItem.id} class={setTasksTab === taskItem.id ? "active" : ""} href={href} role="tab" on:click={()=>handleTab(taskItem.id)}>
            <span class="title"> {taskItem.title}</span>
        </Link>
    </li>
{/each}

